import * as THREE from "three";
import { SCENE_OBJ_NAMES, STANDARD_FPS } from "./constants";
import { sceneObjects } from "./index";
import { circle1, circle2 } from "./circles";
import { degreesToRadians, generateRandomNumber, getNumberAngle, lerp, transformTo0360 } from "./utils";
import { rouletteDiskState } from "./rouletteDisk";
import { gsap } from "gsap";
import { jumpPoints } from "./spin";
import { threeJsSounds } from "./threeJsSounds";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import ballGlb from "./assets/glbModels/ball.glb";

export const ballState = {
  angle: 0,
  angleSpeed: -17,
  fastSpeed: -17,
  slowlySpeed: -6,
  traveledRotation: 0,
  minTravelIngRotation: 1400,
  isInInitialCircularMovement: false,
  isStayOnRouletteDisk: false,
  getAngleRadian: () => degreesToRadians(ballState.angle),
  addAngle: (addingAngle) => ballState.angle = transformTo0360(ballState.angle + (rouletteDiskState.rotationDirection * addingAngle)),
  setBallSpeedByLerp: () => {
    ballState.angleSpeed = lerp(ballState.fastSpeed, ballState.slowlySpeed, ballState.traveledRotation / ballState.minTravelIngRotation)
  },
  onBallAnimationComplete: () => {
  },
}

export const resetBallState = () => {
  ballState.angle = 0;
  ballState.angleSpeed = -12;
  ballState.traveledRotation = 0;
  ballState.isInInitialCircularMovement = false;
  ballState.isStayOnRouletteDisk = false;
  ballState.onBallAnimationComplete = () => {
  };
}

export const addRouletteBall = () => {
  const loader = new GLTFLoader();
  loader.load(ballGlb, (gltf) => {
    const ballGeometry = new THREE.SphereGeometry(0.01125);//(0.009);
    // const ballMaterial = new THREE.MeshBasicMaterial({ color: "rgb(197,191,191)", metalness: 1, roughness: 1 });
    const ballMaterial = gltf.scene.children[0].material;
    const ballMesh = new THREE.Mesh(ballGeometry, ballMaterial);
    ballMesh.position.set(0.3, 0.84, 0.1);
    ballMesh.rotation.x = Math.PI;

    sceneObjects.get(SCENE_OBJ_NAMES.scene).add(ballMesh);
    sceneObjects.set(SCENE_OBJ_NAMES.ball, ballMesh);
  });
}

// export const addRouletteBall = () => {
//   const loader = new GLTFLoader();
//
//   loader.load(ballGlb, (gltf) => {
//     const ballMesh = gltf.scene;
//
//     ballMesh.position.set(0.3, 0, 0.1);
//
//     sceneObjects.get(SCENE_OBJ_NAMES.scene).add(ballMesh);
//     sceneObjects.set(SCENE_OBJ_NAMES.ball, ballMesh);
//   });
// };

export const ballInitialCircularMovement = () => new Promise((resolve) => {
  const animation = () => {
    if (!ballState.isInInitialCircularMovement) {
      return;// resolve();
    }

    requestAnimationFrame(animation);

    const ball = sceneObjects.get(SCENE_OBJ_NAMES.ball);

    const addingAngle = ballState.angleSpeed * (STANDARD_FPS / rouletteDiskState.fps);
    if (isFinite(addingAngle)) {
      ballState.addAngle(addingAngle);
    }

    ballState.traveledRotation += Math.abs(ballState.angleSpeed * (STANDARD_FPS / rouletteDiskState.fps));
    const newPosition = circle1.getPointCoordinates(ballState.getAngleRadian());
    ball?.position.set(newPosition.x, newPosition.y, newPosition.z);
    // circle1.interpolateRadius(Math.min(ballState.traveledRotation / ballState.minTravelIngRotation, 1));
    ballState.setBallSpeedByLerp();

    // const nowAnglesRatio = transformTo0360(ballState.angle - transformTo0360(rouletteDiskState.getAngle() + jumpPoints[0].startAngle));
    // if (ballState.traveledRotation > ballState.minTravelIngRotation && nowAnglesRatio < 3) {
    if (ballState.traveledRotation > ballState.minTravelIngRotation) {
      // stopBallInitialCircularMovement();
      resolve();
    }
  }
  animation();
})

export const stopBallInitialCircularMovement = () => ballState.isInInitialCircularMovement = false;

export let killBallGsapAnimation = () => {
};

export const ballJumpAnimationOnRouletteDisk = ({
                                                  startAngle,
                                                  endAngle,
                                                  duration,
                                                  jumpSteps
                                                }) => new Promise(async(resolve) => {
  const rint = jumpSteps === 0 ? 0 : await generateRandomNumber(jumpSteps);
  const oldRadius = circle2.radius;
  const newRadius = lerp(circle2.radius1, circle2.radius2, rint);
  const interpolation = { alpha: 0 };
  const ball = sceneObjects.get(SCENE_OBJ_NAMES.ball);
  ball.position.y = circle2.y;

  const animation1 = gsap.to(ball.position, {
    y: circle2.y + (0.12 * duration),
    repeat: 1,
    yoyo: true,
    duration: duration / 2,
  });

  const animation2 = gsap.to(interpolation,
    {
      alpha: 1,
      duration,
      onUpdate: () => {
        const angle = lerp(startAngle, endAngle, interpolation.alpha);
        const { x, z } = circle2.getPointCoordinates(degreesToRadians(angle) + rouletteDiskState.getAngleRadian());
        ball.position.x = x;
        ball.position.z = z;
        circle2.setRadius(lerp(oldRadius, newRadius, interpolation.alpha));
      },
      onComplete: () => {
        threeJsSounds.ballHit();
        resolve();
      },
    });

  killBallGsapAnimation = () => {
    animation1.kill();
    animation2.kill();
  };

});


export const updateBallPositionForKeepSameNumberOnRouletteDisk = (targetAngle) => {
  if (!ballState.isStayOnRouletteDisk) {
    return;
  }
  requestAnimationFrame(() => updateBallPositionForKeepSameNumberOnRouletteDisk(targetAngle));

  const ball = sceneObjects.get(SCENE_OBJ_NAMES.ball);
  const { x, y, z } = circle2.getPointCoordinates(rouletteDiskState.getAngleRadian() + degreesToRadians(targetAngle));
  ball.position.x = x;
  ball.position.y = y;
  ball.position.z = z;
}

export const startFallBall = (diskAngle) => {
  let lastAlpha = 0;
  ballState.angleSpeed = -1;
  let jump = {
    alpha: 0, height: 0.06, getHeightByAlpha: () => jump.alpha * jump.height,
    animate: () => {
      gsap.to(jump, {
        alpha: 1, repeat: 1,
        yoyo: true,
        duration: 0.2,
        onComplete: () => threeJsSounds.ballHit()
      })
    }
  };

  return new Promise((resolve) => {
    const fallBall = () => {
      const ball = sceneObjects.get(SCENE_OBJ_NAMES.ball);
      const nowAnglesRatio = transformTo0360(ballState.angle - transformTo0360(rouletteDiskState.getAngle() + diskAngle));
      let alpha = (360 - nowAnglesRatio) / 360;
      if (rouletteDiskState.rotationDirection === -1) {
        alpha = 1 - alpha;
      }
      const alphaDiff = alpha - lastAlpha;
      if (alphaDiff < 0.2 && alphaDiff > 0 && ball) {
        lastAlpha = alpha;
        circle1.interpolateRadius(alpha);
        ball.position.y = lerp(circle1.y, circle2.y, alpha) + jump.getHeightByAlpha();
      }
      if (lastAlpha > 0.97) {
        stopBallInitialCircularMovement();
        resolve()
        return;
      }

      if (ballState.angle % 45 < 2.5 && jump.alpha === 0 && lastAlpha < 0.75) {
        jump.animate();
      }

      requestAnimationFrame(fallBall);
    }
    fallBall();
  })
}
